import * as constants from '@/utils/analytics/constants/constants'
import * as actions from '@/utils/analytics/constants/actions'

export const GLOBAL_SECTION = constants.GLOBAL

export const VERSION_UPDATED = `${ actions.UPDATED } version`
export const NOT_FOUND_PREFIX = `${ constants.NOT_FOUND_CONST } Loaded`
export const NOT_AUTHORIZED = `${ constants.NOT_AUTHORIZED } Loaded`
